/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { Injectable } from '@angular/core';
import { AbstractContactVO } from '@well/domain';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({ providedIn: 'root' })
export class DelContactPhoneableResourceService extends AbstractResourceService<AbstractContactVO, null, null, null> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('delContactPhoneableUrl'));
  }

  getAllContactsForBusinessProfile(businessProfileUuid: string) {
    return this.httpClient?.get<AbstractContactVO[]>(`${this.url}/bp/${businessProfileUuid}`);
  }
}
